import React, { useEffect } from 'react';
import { useUnmount } from 'react-use';
import { connect } from 'react-redux';
import moment from 'moment-timezone';

import { useDebounceLoading } from '../../utils/hookHelper';
import { constructPath, momentUTCDate, getPageTypeCode } from '../../utils/Helper';

import store from '../../redux/store';
import { getIndexPagesList, resetIndexPagesList } from '../../redux/modules/indexPageList/action';
import Loader from '../../components/Loader';
import GridItem from '../GridItem';
import CardSlider from '../CardSlider';

import config from '../../config';

import './IndexCards.scss';
import '../GridList/GridList.scss';

const IndexCards = (props) => {
  const {
    i18n,
    indexPageList,
    query,
    maxCardsInSlider = 3,
    displayAsSlider,
    sortBy = 'contentPublishDate',
  } = props;
  const debounceListLoading = useDebounceLoading(indexPageList);

  useEffect(() => {
    if (query !== '') {
      store.dispatch(getIndexPagesList(query, 0, displayAsSlider ? maxCardsInSlider : 3, sortBy));
    }
  }, [query]);

  useUnmount(() => {
    store.dispatch(resetIndexPagesList());
  });

  const { locale } = i18n;
  moment.locale(config.momentLangMap[locale]);

  // content
  const headline = props.title;
  const { url } = props;
  const { lists = [] } = indexPageList || {};

  const gridEle = () => {
    const data = lists.map((v) => {
      const { fileName = '', content = {}, metadata = {} } = v;
      const displayPublishDate = content.contentPublishDate
        ? moment(momentUTCDate(content.contentPublishDate)).format('LL')
        : '';
      const pageContent = content[locale] || {};
      const pageType = metadata['TeamSite/Templating/DCR/Type'];
      const pageTypeCode = getPageTypeCode(pageType);
      const cardUrl = constructPath(config.routePathTo, locale, pageTypeCode, fileName);
      const { thumbnail } = pageContent;
      return {
        displayPublishDate,
        ...pageContent,
        thumbnail,
        url: cardUrl,
      };
    });

    return (
      <div className={`grids ${displayAsSlider && 'd-flex'}`}>
        {displayAsSlider ? (
          <CardSlider>
            {data.map((v, k) => {
              return (
                <div className="swiper-slide" key={k}>
                  <GridItem content={v} length={150} />
                </div>
              );
            })}
          </CardSlider>
        ) : (
          <>
            {data.map((v, k) => {
              return (
                <div className="grid__wrapper" key={k}>
                  <GridItem content={v} length={150} lazy />
                </div>
              );
            })}
          </>
        )}
      </div>
    );
  };

  const headlineEle = <>{headline && <div className="indexCards__title">{headline}</div>}</>;

  const mainContent = <>{debounceListLoading ? <Loader /> : gridEle()}</>;

  const moreButton = (
    <div className="child-more-item">
      <div className="item-more">
        <a target="_blank" className="button button--ghost-white" href={url}>
          <span>Mehr</span>
        </a>
      </div>
    </div>
  );

  const pageEle = (
    <>
      <section className="section-mainPage-indexCards">
        {headlineEle}
        <div className="indexCards__container">
          {mainContent}
          {moreButton}
        </div>
      </section>
    </>
  );

  return <>{pageEle}</>;
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  indexPageList: state.indexPageList,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(IndexCards);

export { IndexCards as IndexCardsComponent }; // <- For component Unit Test
export default connectStore;
